// Formatage de la date YYYY-MM-DD en DD/MM/YYYY sans impact de fuseau horaire
const formatDate = (date) => {
  if (!date) return "";

  // Si la date contient un T, on ne garde que la partie "YYYY-MM-DD"
  const dateOnly = date.split("T")[0];
  const [year, month, day] = dateOnly.split("-");

  return `${day}/${month}/${year}`;
};

export default formatDate;